module.exports = "../../static/img/logout.801d6b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logout.png
// module id = 1426
// module chunks = 0